<template functional>
  <svg width="100%" height="100%" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="1" width="28" height="5" rx="2.5" transform="rotate(45 6 1)" fill="white"/>
    <rect x="2" y="21" width="28" height="5" rx="2.5" transform="rotate(-45 2 21)" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: 'close-icon'
}
</script>
